export const TENANT_SORTS = [
  {
    key: "slug_asc",
    label: "Slug, A-Z",
  },
  {
    key: "slug_desc",
    label: "Slug, Z-A",
  },
  {
    key: "name_asc",
    label: "Name, A-Z",
  },
  {
    key: "name_desc",
    label: "Name, Z-A",
  },
  {
    key: "created_at_desc",
    label: "Created At, Newest First",
  },
  {
    key: "created_at_asc",
    label: "Created At, Oldest First",
  },
] as const;

export type TenantSort = (typeof TENANT_SORTS)[number]["key"];
